import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { closeButton, modalBackground } from "@/constants";

interface ConfirmDialogProps {
  isCurrentlyEnabled: boolean;
  trigger: any;
  onSuccess: () => void;
}

const IpWhitelistDialog = ({
  isCurrentlyEnabled,
  trigger,
  onSuccess,
}: ConfirmDialogProps) => {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
      <AlertDialogContent className="gap-0 p-0">
        <AlertDialogHeader className="relative z-10 bg-black px-8 py-4">
          <AlertDialogTitle className="w-full text-start font-openSans text-2xl text-white">
            Whitelist {isCurrentlyEnabled ? "Deactivation" : "Activation"}
          </AlertDialogTitle>
          <AlertDialogCancel
            status="neutral"
            className="absolute right-4 top-3 h-6 border-0 bg-black hover:cursor-pointer hover:bg-black"
          >
            <img src={closeButton} />
          </AlertDialogCancel>
        </AlertDialogHeader>
        <AlertDialogFooter className="relative flex flex-col gap-8 overflow-hidden px-8 lg:py-8">
          <img
            className="absolute left-0 top-0 z-0 overflow-hidden"
            src={modalBackground}
            alt="modal background"
          />
          <div
            id="overlay"
            className="absolute -left-2 top-0 z-10 h-full w-full bg-black/70"
          />
          <AlertDialogDescription className="z-10 flex flex-col gap-4 font-openSans text-white">
            <h2 className="text-center text-lg font-semibold">
              Are you sure want to{" "}
              {isCurrentlyEnabled ? "deactivate" : "activate"} whitelist?
            </h2>{" "}
            <p className="text-center text-white/70">
              {isCurrentlyEnabled
                ? "Disabling the Active Whitelist will allow all users, including those not whitelisted, to access the Shakroll platform."
                : "Users not whitelisted will no longer be able to access the Sharkroll platform if you enable the Active Whitelist feature."}
            </p>
          </AlertDialogDescription>
          <div className="z-10 flex gap-4">
            <AlertDialogCancel className="flex w-full rounded-lg bg-black p-[1px]">
              <div className="flex h-full w-full items-center justify-center rounded-md bg-black">
                No
              </div>
            </AlertDialogCancel>
            <AlertDialogAction
              className="w-full rounded-lg"
              onClick={onSuccess}
            >
              Yes
            </AlertDialogAction>
          </div>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default IpWhitelistDialog;
